import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withKeys as _withKeys, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/cancel-small.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  class: "dropdown-menu",
  role: "menu"
}
const _hoisted_5 = { class: "dropdown-content" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import { ref, onMounted, onUnmounted, computed, watch } from 'vue'

import DropdownItem from '@/popup/components/shared/Dropdown/DropdownItem.vue'
import DropdownTrigger from '@/popup/components/shared/Dropdown/DropdownTrigger.vue'

import type { Component } from 'vue'

type Props = {
  selected: any[]
  options: any[]
  isOpen?: boolean
  triggerClass?: string
  optionId?: string
  optionLabel?: string
  isOpenUp?: boolean
  optionComponent?: Component
  triggerComponent?: Component
  canAddTags?: boolean
  validateOnLoad?: boolean
  hasError?: boolean
}

type Emits = {
  (event: 'onChange', options: any[]): void
  (event: 'onAddOption', option: any): void
  (event: 'onRemoveOption', option: any): void
  (event: 'onAddTag', tag?: string): void
  (event: 'onRemoveTag', tag: string): void
  (event: 'onLoad'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownMultiple',
  props: {
    selected: {},
    options: {},
    isOpen: { type: Boolean },
    triggerClass: { default: '' },
    optionId: { default: '' },
    optionLabel: { default: '' },
    isOpenUp: { type: Boolean },
    optionComponent: { default: DropdownItem },
    triggerComponent: { default: DropdownTrigger },
    canAddTags: { type: Boolean },
    validateOnLoad: { type: Boolean },
    hasError: { type: Boolean, default: false }
  },
  emits: ["onChange", "onAddOption", "onRemoveOption", "onAddTag", "onRemoveTag", "onLoad"],
  setup(__props: any, { emit: __emit }) {

const dropdownRef = ref<HTMLElement>()

const props = __props
const emits = __emit
const tagElement = ref<HTMLInputElement>()

const hasObjects = computed(() => {
  return !!props.optionId
})

const onToggleDropdown = () => {
  dropdownRef.value?.classList.toggle('is-active')
  tagElement.value?.focus()
}

const onCloseDropdown = () => {
  dropdownRef.value?.classList.remove('is-active')
}

const optionIndex = (option: any) =>
  props.selected?.findIndex(o => {
    return props.optionId
      ? o[props.optionId] === option[props.optionId]
      : o === option
  })

const onRemoveOption = (option: any) => {
  let selected = [...props.selected] || []
  const index = optionIndex(option)

  if (index > -1) {
    selected.splice(index, 1)
    emits('onRemoveOption', option)
    emits('onChange', selected)
  }
}

const onAddOption = (option: any) => {
  let selected = [...props.selected] || []
  const index = optionIndex(option)

  if (index === -1) {
    selected = [...selected, option]
    emits('onAddOption', option)
    emits('onChange', selected)
  }
}

const addTag = () => {
  emits('onAddTag', tagElement.value?.value)

  if (tagElement.value) {
    tagElement.value.value = ''
  }
}

const changeTagText = (kEvent: KeyboardEvent) => {
  if (
    !!!tagElement.value?.value &&
    (kEvent.code === 'Backspace' || kEvent.code === 'Delete')
  ) {
    emits('onRemoveTag', props.selected.at(-1))
  }
}

watch(
  () => props.validateOnLoad,
  validateOnLoad => {
    if (validateOnLoad) {
      emits('onLoad')
    }
  }
)

onMounted(() => {
  window.addEventListener('click', onCloseDropdown, false)
})

onUnmounted(() => {
  window.removeEventListener('click', onCloseDropdown, false)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown dropdown-multiple", { 'is-active': _ctx.isOpen, 'is-open-up': _ctx.isOpenUp }]),
    role: "dropdown",
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.triggerComponent), {
      selected: _ctx.selected,
      onClick: _withModifiers(onToggleDropdown, ["stop"]),
      onUnselect: onRemoveOption,
      class: _normalizeClass({ 'is-danger': _ctx.hasError }),
      "data-testid": "dropdown-trigger"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected, (tag) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tag,
            class: "input-tag"
          }, [
            (hasObjects.value && _ctx.optionLabel)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(tag[_ctx.optionLabel]), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(tag), 1 /* TEXT */)),
            _createElementVNode("img", {
              src: _imports_0,
              class: "tag-close-icon pl-1",
              "data-testid": "remove-tag",
              onClick: _withModifiers(($event: any) => (onRemoveOption(tag)), ["stop"])
            }, null, 8 /* PROPS */, _hoisted_3)
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        (_ctx.canAddTags)
          ? (_openBlock(), _createElementBlock("input", {
              key: 0,
              ref_key: "tagElement",
              ref: tagElement,
              type: "text",
              name: "addTag",
              class: "tag-input",
              autocomplete: "off",
              "data-testid": "tag-input",
              onKeydown: changeTagText,
              onKeypress: _withKeys(addTag, ["enter"])
            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 40 /* PROPS, NEED_HYDRATION */, ["selected", "class"])),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.optionComponent), {
            key: _ctx.optionId ? option[_ctx.optionId] : option,
            "data-testid": _ctx.optionId ? option[_ctx.optionId] : option,
            option: option,
            onClick: ($event: any) => (onAddOption(option))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.optionLabel)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(option[_ctx.optionLabel]), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(option), 1 /* TEXT */))
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-testid", "option", "onClick"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ], 2 /* CLASS */))
}
}

})